const arabicIndicDigitsMap: Record<string, string> = {
  '٠': '0',
  '١': '1',
  '٢': '2',
  '٣': '3',
  '٤': '4',
  '٥': '5',
  '٦': '6',
  '٧': '7',
  '٨': '8',
  '٩': '9',
};

const easternArabicIndicDigitsMap: Record<string, string> = {
  '۰': '0',
  '۱': '1',
  '۲': '2',
  '۳': '3',
  '۴': '4',
  '۵': '5',
  '۶': '6',
  '۷': '7',
  '۸': '8',
  '۹': '9',
};

/**
 * Convert Arabic/Eastern Arabic-Indic digits to ASCII digits.
 * Also normalizes Arabic decimal/thousands separators to "." and ",".
 */
export function toEnglishDigits(value: string): string {
  return value
    .replace(/[٠-٩]/g, (d) => arabicIndicDigitsMap[d] ?? d)
    .replace(/[۰-۹]/g, (d) => easternArabicIndicDigitsMap[d] ?? d)
    .replace(/٬/g, ',') // Arabic thousands separator
    .replace(/٫/g, '.'); // Arabic decimal separator
}

export function toEnglishDigitsSafe(value: number | string | null | undefined): string {
  if (value == null) return '—';
  return toEnglishDigits(String(value));
}

